<template>
  <div class="login" style="height: 100%">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">
          {{
            this.$route.query.appName
            ? "【" + this.$route.query.appName + "】" + $t("editing") + "..."
            : $t("apps.new")
          }}
        </h2>
      </div>
      <div class="weui-form__control-area" style="
          max-width: 500px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        ">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("apps.name") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="appName" class="weui-input" ref="appName" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("apps.localPort") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="srcPort" class="weui-input" ref="srcPort" />
              </div>
            </div>
            <div>
              <label class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after">
                <div class="weui-cell__hd">
                  <span class="weui-label">{{ $t("apps.protocol") }}</span>
                </div>
                <div class="weui-cell__bd">
                  <select class="weui-select" v-model="protocol">
                    <option value="tcp">TCP</option>
                    <option value="udp">UDP</option>
                  </select>
                </div>
              </label>
            </div>

            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("apps.localNode") }}</label>
              </div>
              <div class="weui-cell__bd" style="color: #645f5f">
                {{ this.$route.params.nodeName }}
              </div>
            </div>
            <div v-if="showSpecRelay" class="weui-cell weui-cell_active
              weui-cell_select weui-cell_select-after">
              <div class="weui-cell__hd">
                {{ $t("sdwan.specifiedRelayNode") }}<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </div>

              <div class="weui-cell__hd weui-cell weui-cell_active weui-cell_select weui-cell_select-after"
                style="padding-left: 0px;width: 200px;">
                <div class="weui-cell__bd container">
                  <select class="weui-select" style="
            background-color: rgba(24, 24, 24, 0.4);
            fontsize: 20px;
            color: rgb(255, 255, 255);
           
          " v-model="specRelayNode">
                    <option value="" selected>
                      {{ $t("sdwan.notSpecified") }}
                    </option>
                    <option v-for=" node  in  relayNodes " :key="node.name" :value="node.name">
                      {{ node.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="weui-cell__ft">
                <button type="button" v-on:click="showCentralTip" class="weui-btn_reset weui-btn_icon">
                  <i role="img" alt="帮助" class="js_target weui-icon-info-circle"></i>
                </button>
              </div>
            </div>
            <div>
              <label class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after">
                <div class="weui-cell__hd">
                  <span class="weui-label">{{ $t("apps.remoteNode") }}</span>
                </div>
                <div class="weui-cell__bd">
                  <select class="weui-select" style="background-color: rgba(24, 24, 24, 0.4)" v-model="peerNode">
                    <option selected>{{ this.peerNode }}</option>
                    <option v-for="( node, i ) in  remoteNodes " :value="node.name" :key="i"
                      :class="{ InactiveNode: node.isActive != 1 }" style="background-color: rgba(24, 24, 24, 0.9)">
                      {{ node.name }}
                      <p v-if="!node.isActive">({{ $t("offline") }})</p>
                    </option>
                  </select>
                </div>
              </label>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("apps.dstHost") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="dstHost" class="weui-input" ref="dstHost" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("apps.dstPort") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="dstPort" class="weui-input" ref="dstPort" />
              </div>
            </div>
            <div v-if="showWhitelist" class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("apps.whitelist") }}</label>
              </div>
              <div class="weui-cell__bd">
                <input v-model="whitelist" class="weui-input" ref="whitelist" />
              </div>
              <div class="weui-cell__ft">
                <button type="button" v-on:click="showTooltip" class="weui-btn_reset weui-btn_icon">
                  <i role="img" alt="帮助" class="js_target weui-icon-info-circle"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area">
        <a class="weui-btn weui-btn_primary" v-on:click="save" href="javascript:">{{ $t("save") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
export default {
  name: "appedit",
  computed: {
    remoteNodes() {
      var nodes = Array.from(this.$store.state.nodes)
      return nodes.filter(
        (node) =>
          node.name != this.$route.params.nodeName && node.name != this.peerNode
      )
    },
    relayNodes() {
      return this.$store.state.nodes.filter(
        (node) =>
          (node.natType == 1 || node.hasIPv4 == 1 || node.hasUPNPorNATPMP == 1) && node.isActive
      )
    },
    showWhitelist() {
      var version
      this.$store.state.nodes.forEach((v) => {
        if (v.name == this.$route.params.nodeName) {
          version = v.version
          console.log("version:", version)
        }
      })
      if (this.$compareVersions(version, "3.10.2") == 1) {
        // > 3.10.2 client support whitelist
        return true
      }
      return false
    },
    showSpecRelay() {
      var version
      this.$store.state.nodes.forEach((v) => {
        if (v.name == this.$route.params.nodeName) {
          version = v.version
          console.log("version:", version)
        }
      })
      if (this.$compareVersions(version, "3.16.1") > 0) {
        return true
      }
      return false
    },
  },
  async mounted() {
    console.log("appEdit " + this.$route.query)
    this.appName = this.$route.query.appName
    this.protocol = this.$route.query.protocol
    this.srcPort = this.$route.query.srcPort
    // this.peerNode = this.$route.query.peerNode ? this.$route.query.peerNode : '请选择'
    this.dstHost = this.$route.query.dstHost
    this.dstPort = this.$route.query.dstPort
    this.whitelist = this.$route.query.whitelist
    this.peerNode = this.$route.query.peerNode
    this.specRelayNode = this.$route.query.specRelayNode
    // if (this.$store.state.apps.length > 1) {

    // } else {
    // refresh the page will clear state.apps
    // console.log("load again")
    // let res = await axios.get(this.$ServerHost + "/api/v1/devices")
    // if (res && res.data.nodes) {
    //   this.$store.commit("setNodes", res.data.nodes)
    // }
    // }
    // auto select one node when new app
    if (!this.$route.query.peerNode) {
      this.appName = this.$t("apps.new")
      this.dstHost = "localhost"
      this.protocol = "tcp"
      this.srcPort = 222
      this.dstPort = 22
      for (let i = 0; i < this.$store.state.nodes.length; i++) {
        console.log("check srcport:", this.$store.state.nodes[i])
        if (this.$store.state.nodes[i].name != this.$route.params.nodeName) {
          this.peerNode = this.$store.state.nodes[i].name
          this.node = this.$store.state.nodes[i]
          console.debugLog("appedit:", this.node)
          if (
            this.$store.state.nodes[i].os.toLowerCase().indexOf("windows") != -1
          ) {
            this.dstPort = 3389
            this.srcPort = 23389
          }
          break
        }
      }
    }
    console.log("appedit: ", this.$store.state.nodes)
  },
  data() {
    return {
      appName: "",
      specRelayNode: "",
      protocol: "",
      srcPort: 0,
      peerNode: "",
      dstHost: "",
      dstPort: 0,
      whitelist: "",
      node: {},
    }
  },
  props: {
    msg: String,
  },
  methods: {
    showTooltip() {
      weui.alert(
        this.$t("apps.whitelistTips1") +
        "</br>" +
        this.$t("apps.whitelistTips2"),
        {
          buttons: [
            {
              label: this.$t("ok"),
              onClick: function () { },
            },
          ],
        }
      )
      return
    },
    showCentralTip() {
      weui.alert(this.$t("sdwan.centralTips"), {
        buttons: [
          {
            label: this.$t("ok"),
            onClick: function () { },
          },
        ],
      })
      return
    },
    save() {
      var error
      if (this.appName?.length > 32) {
        error = this.$t("apps.tooLong")
      }
      if (this.peerNode == this.$t("apps.pleaseChoose")) {
        error = this.$t("apps.notChosen")
      }
      if (this.dstPort < 0 || this.dstPort > 65535) {
        error = this.$t("apps.errPortRange")
      }
      if (this.srcPort < 0 || this.srcPort > 65535) {
        error = this.$t("apps.errPortRange")
      }
      // TODO: check protocol+srcPort
      for (let i = 0; i < this.$store.state.apps.length; i++) {
        console.log("check srcport:", this.$store.state.apps[i])
        if (
          this.$store.state.apps[i].srcPort == this.srcPort &&
          this.$store.state.apps[i].protocol == this.protocol &&
          this.$store.state.apps[i].srcPort != this.$route.query.srcPort
        ) {
          error =
            this.$t("apps.port") +
            " " +
            this.srcPort +
            " " +
            this.$t("apps.hasBeen") +
            this.$store.state.apps[i].appName +
            this.$t("apps.occupy")
          break
        }
      }
      if (error) {
        weui.alert(error, {
          buttons: [
            {
              label: this.$t("ok"),
            },
          ],
        })
        return false
      }
      // warning if version not equal
      var version, peerVersion, warning
      warning = ""
      this.$store.state.nodes.forEach((v) => {
        if (v.name == this.peerNode) {
          peerVersion = v.version
          console.log("peerVersion:", peerVersion)
        }
        if (v.name == this.$route.params.nodeName) {
          version = v.version
          console.log("version:", version)
          if (this.srcPort < 10000 && v.os == "Android") {
            warning += this.$t("apps.androidListenPortTooLow")
            warning += "<br>"
          }
        }
      })

      console.log("peerVersion:", peerVersion, "version:", version)
      if (peerVersion != version) {
        warning += this.$t("apps.diffVer")
      }
      console.log("save app edit", this.$refs.appName.placeholder)
      let _this = this
      axios
        .post(
          this.$ServerHost +
          "/api/v1/device/" +
          encodeURIComponent(this.$route.params.nodeName) +
          "/push?subtype=9",
          {
            appName: this.$data.appName
              ? this.$data.appName
              : this.$refs.appName.placeholder,
            protocol: this.$data.protocol
              ? this.$data.protocol
              : this.$refs.protocol.placeholder,
            srcPort: this.$data.srcPort
              ? +this.$data.srcPort
              : +this.$refs.srcPort.placeholder,
            protocol0: this.$route.query.protocol, //protocol0+srcPort0 is the p2papp's id
            srcPort0: +this.$route.query.srcPort,
            peerNode: this.$data.peerNode
              ? this.$data.peerNode
              : this.$refs.peerNode.placeholder,
            dstHost: this.$data.dstHost
              ? this.$data.dstHost
              : this.$refs.dstHost.placeholder,
            dstPort: this.$data.dstPort
              ? +this.$data.dstPort
              : +this.$refs.dstPort.placeholder,
            whitelist: this.$data.whitelist ? this.$data.whitelist : "",
            specRelayNode: this.$data.specRelayNode ? this.$data.specRelayNode : "",
          }
        )
        .then((response) => {
          console.log(response)
          if (response.status == 200) {
            weui.alert(_this.$t("saveOK") + "<br>" + warning, {
              buttons: [
                {
                  label: _this.$t("ok"),
                  onClick: function () {
                    _this.$router.go(-1)
                    localStorage.setItem("createApp", "1")
                  },
                },
              ],
            })
          } else {
            console.log("login error:" + response)
          }
        })
        .catch(function () {
          weui.alert(_this.$t("saveError"), {
            buttons: [
              {
                label: _this.$t("ok"),
              },
            ],
          })
        })
    },
  },
}
</script>

<style scoped>
@import "../../assets/css/weui.scss";
</style>
